/* src/app/fitter/pages/fitter-new/fitter-new.component.scss */
/*# sourceMappingURL=fitter-new.component.css.map */
